import { ReactElement, useState } from 'react';
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import appServices from "../services/app-services/appServices";
import { openUrl } from '../util/PortalAppFunction';
import { ErrorMessageModal } from './ErrorMessageModal';

interface Props {
  post_id: number;
  attachment: any;
}

function PostAttachment({ post_id, attachment }: Props): ReactElement {
  const { user } = useSelector((state: any) => state.userAuth);
  const [errors, setErrors] = useState<any[]>([]);

  const handleClickUrl = async (event: any) => {
    event.preventDefault();

    let url;
    try {
      url = await appServices.requestAccessAttachment(post_id, attachment.id, user.id);
    } catch (e: any) {
      setErrors(e?.response?.data?.message ?? [T("api_unknown_error")]);
      return
    }
    openUrl(url);
  }

  return (
    <>
      <a href="_" onClick={handleClickUrl}>{attachment?.name}</a>
      <ErrorMessageModal
        open={errors.length > 0}
        messages={errors}
        onClose={() => setErrors([])}
      />
    </>
  );
};

export default PostAttachment;
